import React from 'react';
import ContentItemBlock from './ContentItem.block';
import { staticImageAssets } from 'js/constants/Paths';

const ContentItemGrid = ({ title = '', twoHero = false, data = PLACEHOLDER_DATA, type = false }) => {
  const renderContentItems = () => {
    return data.map((item, index) => {
      return item ? <ContentItemBlock item={item} key={item.id} index={index} /> : null;
    });
  };

  return (
    <div className="content-grid">
      {title !== '' && (
        <h2 className={'content-grid__title' + (type ? ' content-grid__title--' + type : '')}>{title}</h2>
      )}
      <ul className={'content-item__grid' + (twoHero ? ' content-item__grid--2-hero' : '')}>{renderContentItems()}</ul>
    </div>
  );
};

export default ContentItemGrid;

const PLACEHOLDER_DATA = [
  {
    id: 1,
    title: 'Title 1',
    description: 'Description 1',
    imageUrl: staticImageAssets(`images/static/540x304.png`),
    link: '',
  },
  {
    id: 2,
    title: 'Title 2',
    description: 'Description 2',
    imageUrl: staticImageAssets(`images/static/540x304.png`),
    link: '',
  },
  {
    id: 3,
    title: 'Title 3',
    description: 'Description 3',
    imageUrl: staticImageAssets(`images/static/540x304.png`),
    link: '',
  },
  {
    id: 4,
    title: 'Title 4',
    description: 'Description 4',
    imageUrl: staticImageAssets(`images/static/540x304.png`),
    link: '',
  },
  {
    id: 5,
    title: 'Title 5',
    description: 'Description 5',
    imageUrl: staticImageAssets(`images/static/540x304.png`),
    link: '',
  },
  {
    id: 6,
    title: 'Title 6',
    description: 'Description 6',
    imageUrl: staticImageAssets(`images/static/540x304.png`),
    link: '',
  },
  {
    id: 7,
    title: 'Title 7',
    description: 'Description 7',
    imageUrl: staticImageAssets(`images/static/540x304.png`),
    link: '',
  },
  {
    id: 8,
    title: 'Title 8',
    description: 'Description 8',
    imageUrl: staticImageAssets(`images/static/540x304.png`),
    link: '',
  },
  {
    id: 9,
    title: 'Title 9',
    description: 'Description 9',
    imageUrl: staticImageAssets(`images/static/540x304.png`),
    link: '',
  },
  {
    id: 10,
    title: 'Title 10',
    description: 'Description 10',
    imageUrl: staticImageAssets(`images/static/540x304.png`),
    link: '',
  },
  {
    id: 11,
    title: 'Title 11',
    description: 'Description 11',
    imageUrl: staticImageAssets(`images/static/540x304.png`),
    link: '',
  },
  {
    id: 12,
    title: 'Title 12',
    description: 'Description 12',
    imageUrl: staticImageAssets(`images/static/540x304.png`),
    link: '',
  },
];
